module.exports = __webpack_public_path__ + "static/media/aquis.a22eeaf1.pdf";